/* Localised strings for the Recharge login page (/tools/recurring/login).
   Recharge serves this page in English only; the Affinity portal after login
   is translated by Recharge itself. Runs only on non-English locales. */
(function () {
  var lang = document.documentElement.lang;
  if (window.location.pathname.indexOf('/tools/recurring/') === -1) return;

  var DICTS = {
    fr: {
      'Login': 'Connexion',
      'Email': 'E-mail',
      'Sorry, we could not find your account': "Désolé, nous n'avons pas trouvé votre compte",
      'Send login code (sends SMS and email)': 'Envoyer le code de connexion (par SMS et e-mail)',
      'We sent you a code!': 'Nous vous avons envoyé un code !',
      'Enter verification code': 'Saisissez le code de vérification',
      'Invalid code': 'Code invalide',
      'Validating...': 'Vérification...',
      'Redirecting...': 'Redirection...',
      "You'll also receive an SMS if we have your number on file": 'Vous recevrez aussi un SMS si nous avons votre numéro'
    },
    es: {
      'Login': 'Iniciar sesión',
      'Email': 'Correo electrónico',
      'Sorry, we could not find your account': 'Lo sentimos, no encontramos tu cuenta',
      'Send login code (sends SMS and email)': 'Enviar código de acceso (por SMS y correo)',
      'We sent you a code!': '¡Te hemos enviado un código!',
      'Enter verification code': 'Introduce el código de verificación',
      'Invalid code': 'Código no válido',
      'Validating...': 'Validando...',
      'Redirecting...': 'Redirigiendo...',
      "You'll also receive an SMS if we have your number on file": 'También recibirás un SMS si tenemos tu número'
    },
    it: {
      'Login': 'Accedi',
      'Email': 'E-mail',
      'Sorry, we could not find your account': 'Spiacenti, non abbiamo trovato il tuo account',
      'Send login code (sends SMS and email)': 'Invia codice di accesso (via SMS ed e-mail)',
      'We sent you a code!': 'Ti abbiamo inviato un codice!',
      'Enter verification code': 'Inserisci il codice di verifica',
      'Invalid code': 'Codice non valido',
      'Validating...': 'Verifica in corso...',
      'Redirecting...': 'Reindirizzamento...',
      "You'll also receive an SMS if we have your number on file": 'Riceverai anche un SMS se abbiamo il tuo numero'
    },
    nl: {
      'Login': 'Inloggen',
      'Email': 'E-mail',
      'Sorry, we could not find your account': 'Sorry, we konden je account niet vinden',
      'Send login code (sends SMS and email)': 'Verstuur inlogcode (via sms en e-mail)',
      'We sent you a code!': 'We hebben je een code gestuurd!',
      'Enter verification code': 'Voer de verificatiecode in',
      'Invalid code': 'Ongeldige code',
      'Validating...': 'Bezig met valideren...',
      'Redirecting...': 'Doorverwijzen...',
      "You'll also receive an SMS if we have your number on file": 'Je ontvangt ook een sms als we je nummer hebben'
    }
  };
  var T = DICTS[lang];
  if (!T) return;

  function translateLoginPage() {
    var selectors = [
      '.rc-login--header-title',
      '.rc-login-form-label',
      '[data-rc-email-error]',
      '[data-rc-login-form-submit-btn-animation] span',
      '.rc-enter-code-header',
      '.rc-enter-code-text',
      '[data-rc-error-digits] span',
      '[data-rc-submitted-loading] span',
      '[data-rc-redirect-text]',
      '.rc-enter-code-sms-info'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var text = el.textContent.trim();
        if (T[text]) el.textContent = T[text];
      });
    });
    var emailInput = document.querySelector('[data-rc-email-input]');
    if (emailInput && T[emailInput.placeholder]) emailInput.placeholder = T[emailInput.placeholder];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateLoginPage);
  } else {
    translateLoginPage();
  }
})();
